import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import './UsersPage.css';

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db,"users grocery"));
        const usersData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setUsers(usersData);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleDelete = async (userId) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteDoc(doc(db,"users grocery", userId));
        setUsers(users.filter(user => user.id !== userId));
      } catch (error) {
        console.error("Error deleting user:", error);
      }
    }
  };

  return (
    <div className="users-container">
      <div className="users-header">
        <h2>Users</h2>
        <Link to="/users/add" className="add-user-btn">
          + Add User
        </Link>
      </div>

      <div className="users-actions">
        <div className="entries-control">
          Show 
          <select>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </select> 
          entries
        </div>
        <div className="export-buttons">
          <button>Export CSV</button>
          <button>Export Excel</button>
          <button>Print</button>
          <button>Export PDF</button>
        </div>
        <div className="search-box">
          <input type="text" placeholder="Search..." />
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading users...</div>
      ) : (
        <>
          <table className="users-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Name</th>
                <th>Role</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.prefix} {user.firstName} {user.lastName}</td>
                  <td>{user.role}</td>
                  <td>{user.email}</td>
                  <td className="action-buttons">
                    <Link to={`/users/edit/${user.id}`} className="edit-btn">Edit</Link>
                    <Link to={`/users/view/${user.id}`} className="view-btn">View</Link>
                    <button onClick={() => handleDelete(user.id)} className="delete-btn">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="table-footer">
            <div>Showing 1 to {users.length} of {users.length} entries</div>
            <div className="copyright">
              Ultimate POS - V6.7 | Copyright © 2025 All rights reserved.
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UsersPage;